module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[114]113.fcc69e1.woff2";